import { GoldenRecordAccountMappingDto } from './GoldenRecordAccountMappingDto';

export class GoldenRecordAccountDto {
  mapping?: GoldenRecordAccountMappingDto;
  serialId: number;
}
